import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

import { AUTH_TOKEN_COOKIE, getAuthTokenCookieDomain } from 'shared/constants/cookies';
import { authApi } from 'container/authApi';

/**
 * Clears the shared auth cookie and ends the server session so every pre-login flow starts clean.
 * Pass `enabled = false` on authenticated routes (the active-sessions page), which must keep the
 * session they were opened with.
 */
export const useRemoveAuthTokenCookieAndLogoutOnMount = (enabled = true) => {
  const [, , removeCookie] = useCookies<string>([AUTH_TOKEN_COOKIE]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    removeCookie(AUTH_TOKEN_COOKIE, {
      domain: getAuthTokenCookieDomain(),
      path: '/',
      secure: true,
    });
    authApi.logout();
    // reason: `removeCookie` from react-cookie is a new reference on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
};
